import Nullstack from 'nullstack';
export default function IconRss({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-rss",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "19",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M4 4a16 16 0 0 1 16 16"
  }), "   ", Nullstack.element("path", {
    d: "M4 11a9 9 0 0 1 9 9"
  }), " ");
}